import { RootState } from '@/state/store';
import { useSelector } from 'react-redux';

export function use_slice_pick_base<TStoreKey extends keyof RootState, TSlice extends RootState[TStoreKey], TSliceKey extends keyof TSlice>(
  key_slice: TStoreKey,
  keys: TSliceKey[],
): Pick<TSlice, TSliceKey> {
  const out = {} as Pick<TSlice, TSliceKey>;

  for (const key of keys) {
    out[key] = useSelector((state: RootState) => (state[key_slice] as any)[key]);
  }

  return out;
}
